import { useEffect, useState } from "react";
import { api, getUser } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Palmtree } from "lucide-react";

const NOTIF_LABELS = {
  task_assigned: "Aufgabe zugewiesen",
  task_deadline_soon: "Deadline in Kürze",
  task_overdue: "Aufgabe überfällig",
  mention_in_comment: "Erwähnung in Kommentar",
  order_team_changed: "Team-Änderung",
  order_status_changed: "Auftrag-Status geändert",
  payment_received: "Zahlung eingegangen",
  inquiry_new: "Neue Anfrage",
  payment_reminder_sent: "Zahlungserinnerung versendet",
};

export default function MeinProfil() {
  const [prefs, setPrefs] = useState(null);
  const [ooo, setOoo] = useState({ enabled: false, from: "", to: "", substitute_user_id: "" });
  const [users, setUsers] = useState([]);
  const me = getUser();

  useEffect(() => {
    api.get("/mein-profil/notification-preferences").then((r) => setPrefs(r.data.prefs));
    api.get("/mein-profil/out-of-office").then((r) => setOoo({ enabled: !!r.data.enabled, from: r.data.from || "", to: r.data.to || "", substitute_user_id: r.data.substitute_user_id || "" }));
    api.get("/team/users-lite").then((r) => setUsers(r.data.filter((u) => u.id !== me.id)));
     
  }, []);

  const toggle = (evt, kanal) => setPrefs({ ...prefs, [evt]: { ...prefs[evt], [kanal]: !prefs[evt][kanal] } });

  const savePrefs = async () => {
    await api.put("/mein-profil/notification-preferences", { prefs });
    toast.success("Präferenzen gespeichert.");
  };
  const saveOoo = async () => {
    try {
      const body = { enabled: ooo.enabled, from: ooo.from || null, to: ooo.to || null, substitute_user_id: ooo.substitute_user_id || null };
      await api.put("/mein-profil/out-of-office", body);
      toast.success("Abwesenheit gespeichert.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Fehlgeschlagen."); }
  };

  return (
    <div className="space-y-6" data-testid="mein-profil-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Mein Profil</h1>
        <p className="text-sm text-slate-500 mt-1">Benachrichtigungs-Präferenzen und Abwesenheit.</p>
      </div>

      <Card className="border-slate-200" data-testid="ooo-card">
        <CardHeader><CardTitle className="text-base flex items-center gap-2"><Palmtree className="w-4 h-4" /> Abwesenheit / Vertretung</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-3">
            <Switch checked={ooo.enabled} onCheckedChange={(v) => setOoo({ ...ooo, enabled: v })} data-testid="ooo-enabled" />
            <span className="text-sm">Ich bin abwesend</span>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Von</Label>
              <Input type="datetime-local" value={ooo.from ? ooo.from.substring(0, 16) : ""} onChange={(e) => setOoo({ ...ooo, from: e.target.value ? new Date(e.target.value).toISOString() : "" })} data-testid="ooo-from" />
            </div>
            <div>
              <Label>Bis</Label>
              <Input type="datetime-local" value={ooo.to ? ooo.to.substring(0, 16) : ""} onChange={(e) => setOoo({ ...ooo, to: e.target.value ? new Date(e.target.value).toISOString() : "" })} data-testid="ooo-to" />
            </div>
          </div>
          <div>
            <Label>Vertretung</Label>
            <Select value={ooo.substitute_user_id || "__none__"} onValueChange={(v) => setOoo({ ...ooo, substitute_user_id: v === "__none__" ? "" : v })}>
              <SelectTrigger data-testid="ooo-substitute"><SelectValue placeholder="—" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__none__">— keine —</SelectItem>
                {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <Button onClick={saveOoo} data-testid="ooo-save">Speichern</Button>
        </CardContent>
      </Card>

      {prefs && (
        <Card className="border-slate-200" data-testid="prefs-card">
          <CardHeader><CardTitle className="text-base">Meine Benachrichtigungen</CardTitle></CardHeader>
          <CardContent>
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-xs uppercase tracking-wider text-slate-500">
                  <th className="py-2">Ereignis</th>
                  <th className="py-2 text-center">In-App</th>
                  <th className="py-2 text-center">E-Mail</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(NOTIF_LABELS).map(([k, l]) => (
                  <tr key={k} className="border-b border-slate-100 last:border-0" data-testid={`pref-row-${k}`}>
                    <td className="py-2">{l}</td>
                    <td className="py-2 text-center"><Switch checked={prefs[k]?.inapp} onCheckedChange={() => toggle(k, "inapp")} data-testid={`pref-${k}-inapp`} /></td>
                    <td className="py-2 text-center"><Switch checked={prefs[k]?.email} onCheckedChange={() => toggle(k, "email")} data-testid={`pref-${k}-email`} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Button onClick={savePrefs} className="mt-4" data-testid="prefs-save">Speichern</Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
